import { CollectionName } from '../../constants';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const migratePrivateDocument = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const newData = { ...data } as Record<string, unknown>;

  // Other documents
  const otherDocuments = [
    data.otherDocuments,
    data.annualReports,
    data.assetInfoDocuments,
    data.depositBoxAgreement,
    data.reportsAndStatements,
    data.documents,
    data.ownershipProof,
  ]
    .filter(Boolean)
    .flat();

  delete data.annualReports;
  delete data.assetInfoDocuments;
  delete data.depositBoxAgreement;
  delete data.reportsAndStatements;
  delete data.documents;
  delete data.ownershipProof;

  if (otherDocuments) {
    newData.otherDocuments = otherDocuments;
  }

  // Powers documents
  const powersDocuments = [data.powersOfAttorney, data.powers].filter(Boolean).flat();

  delete data.powers;

  if (powersDocuments.length) {
    newData.powersOfAttorney = powersDocuments;
  }

  // Comments
  const comments = [
    data.commentsOnTheAsset,
    data.powersComments,
    data.assetInfoComment,
    data.comments,
  ]
    .filter(Boolean)
    .join(' ');

  delete data.commentsOnTheAsset;
  delete data.powersComments;
  delete data.assetInfoComment;

  if (comments) {
    newData.commentsOnTheAsset = comments;
  }

  return newData;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.ASSETS, migrateItemFunction: migratePrivateDocument },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration8: MigrationType = {
  migrate,
  version: 9,
};
